import { render, staticRenderFns } from "./NotifyIcon.vue?vue&type=template&id=372886e0"
import script from "./NotifyIcon.vue?vue&type=script&lang=js"
export * from "./NotifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports